import React from 'react';
import WearablesContainer from './WearablesContainer';

interface Props {
  redirectUri: string;
}

const WearablesPage: React.FC<Props> = ({ redirectUri }) => {
  return <WearablesContainer redirectUri={redirectUri} />;
};

export default WearablesPage;
